import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 mt-8 items-center mb-8" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-8 justify-center" }

import Home from "@/components/Home.vue";
import Page from "@/components/Page.vue";
import Swoosh from "@/components/identity/Swoosh.vue";
import BeforeAfter from "@/components/identity/BeforeAfter.vue";
import Quote from "@/components/identity/Quote.vue";
import PoslednikVideo from "@/components/identity/PoslednikVideo.vue";
import Slogan from "@/components/identity/Slogan.vue";
import ContentMaxWidth from "@/components/ContentMaxWidth.vue";
import Button from "@/components/Button.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, null, {
    default: _withCtx(() => [
      _createVNode(ContentMaxWidth, { width: 800 }, {
        default: _withCtx(() => [
          _createVNode(Slogan, { class: "mb-8" }),
          _createVNode(Swoosh),
          _createVNode(PoslednikVideo),
          _createVNode(Swoosh),
          _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, " Nam placerat euismod dictum. Maecenas scelerisque nisi ac ipsum vehicula hendrerit ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-4" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu ante dolor. Suspendisse vel ante nibh. Curabitur sagittis elementum orci, ut condimentum justo condimentum ut. ", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", null, " Praesent accumsan, mi sed consectetur cursus, turpis massa congue magna. ", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Button, null, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Unfallinstand- setzung", -1)
              ]))]),
              _: 1
            }),
            _createVNode(Button, null, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Camper & Caravan", -1)
              ]))]),
              _: 1
            }),
            _createVNode(Button, null, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Bus & LKW", -1)
              ]))]),
              _: 1
            }),
            _createVNode(Button, null, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Sonderlackierung", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(BeforeAfter, {
            before: "images/before-after/1/Bild4.jpg",
            after: "images/before-after/1/Bild61.jpg"
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(BeforeAfter, {
            before: "images/before-after/2/Bild9.jpg",
            after: "images/before-after/2/Bild71.jpg"
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(ContentMaxWidth, { width: 800 }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mb-8" }, " Cras quis vehicula ipsum, et suscipit odio. Pellentesque sit amet ex vel orci venenatis ornare. Donec vel quam dictum, tincidunt ante in, feugiat leo. Mauris quis lectus tincidunt, egestas diam sit amet, mollis nunc. Etiam efficitur erat justo, id lacinia est tincidunt sollicitudin. Aenean lobortis tincidunt suscipit. Vestibulum ante ipsum primis in ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, " Donec eu eros quis metus porta tincidunt ", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", null, " Quisque et molestie nulla. Vestibulum bibendum, libero ut ornare pulvinar, ante massa congue lorem, non ornare dui enim id elit. Fusce maximus feugiat sodales. Donec eu eros quis metus porta tincidunt. Phasellus eu leo non magna blandit tempor vel nec dolor. Integer congue erat ac justo finibus fermentum. In dolor augue, imperdiet nec urna ut, convallis sollicitudin tellus. Cras sed ullamcorper erat. ", -1)),
            _createVNode(Quote, null, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Haben wir dein Interesse geweckt?", -1)
              ]))]),
              _: 1
            }),
            _cache[11] || (_cache[11] = _createElementVNode("img", {
              class: "w-full",
              src: "images/Bild66.jpg",
              alt: ""
            }, null, -1)),
            _createVNode(Swoosh)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})